import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import QRCode from 'qrcode';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventWidgetModal.css';
import widgetIcon from '../../../images/widget-preview.png';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventWidgetModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AWSDomain: 'https://s3.amazonaws.com/prdv2-dt-static/',
            publicDomain: 'https://www.showtix4u.com/',
            qrCode: '',
        }
    }

    getCodeSnippet = () => {
        let html = strings.comment1 + '\n';
        html += '<div id="stx-container"></div>' + '\n';
        html += '<script src="' + process.env.REACT_APP_PUBLIC_URL_PRETTY + '/widget.js"></script>' + '\n';
        html += '<script>' + '\n';
        html += 'showtixWidget.loadEvents(' + this.props.current_client_id + ', ' + this.state.widgetModalEventID + ');' + '\n';
        html += '</script>' + '\n';
        html += strings.comment2;
        return html;
    }

    toggle = () => {
        this.props.toggleWidgetModal();
    }

    componentWillMount() {
        this.setState({
            modal: this.props.isToggleWidgetModalOpen
        });
    }

    componentWillReceiveProps(props) {
        this.setState({widgetModalEventID: props.widgetModalEventID },
            () => this.setState({
                modal: this.props.isToggleWidgetModalOpen,
                eventPrettyUrl: 'https://www.showtix4u.com/event-details/' + this.state.widgetModalEventID,
                codeSnippet: this.getCodeSnippet()
            }, () => {
                this.getQRCode();
            })
        );
    }

    getQRCode = async () => {
        let qrCode = await QRCode.toDataURL(`https://www.showtix4u.com/event-details/${this.state.widgetModalEventID}`);
        this.setState({
            qrCode,
        });
    }

    downloadQRCode = () => {
        let tab = window.open();
        setTimeout(() => {
            tab.document.title = 'Your Event QR Code';
            tab.document.close();
            tab.focus();
        }, 200);
        tab.document.write(`<img src="${this.state.qrCode}" />`);
    }

    copyHtmlToClipboard = () => {
        var originalInput = document.getElementById('modal-event-widget__code-snippet');
        // Create a new textarea element and give it id='temp_element'
        var textarea = document.createElement('textarea');
        textarea.id = 'temp_element2';
        // Optional step to make less noise on the page, if any!
        textarea.style.height = 0;
        // Now append it to your page somewhere, I chose <body>
        document.body.appendChild(textarea);
        // Give our textarea a value of whatever inside the div of id=containerid
        textarea.value = originalInput.value;
        // Now copy whatever inside the textarea to clipboard
        var selector = document.querySelector('#temp_element2');
        selector.select();
        document.execCommand('copy');
        // Remove the textarea
        document.body.removeChild(textarea);
        setTimeout(function () { originalInput.select(); }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.

        // focus & select text in the field
        originalInput.focus();
        originalInput.select();
    }

    copyUrlToClipboard = () => {
        var originalInput = document.getElementById('modal-event-widget__url');
        // Create a new textarea element and give it id='temp_element'
        var textarea = document.createElement('textarea');
        textarea.id = 'temp_element3';
        // Optional step to make less noise on the page, if any!
        textarea.style.height = 0;
        // Now append it to your page somewhere, I chose <body>
        document.body.appendChild(textarea);
        // Give our textarea a value of whatever inside the div of id=containerid
        textarea.value = originalInput.value;
        // Now copy whatever inside the textarea to clipboard
        var selector = document.querySelector('#temp_element3');
        selector.select();
        document.execCommand('copy');
        // Remove the textarea
        document.body.removeChild(textarea);
        setTimeout(function () { originalInput.select(); }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.

        // focus & select text in the field
        originalInput.focus();
        originalInput.select();
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isToggleWidgetModalOpen} toggle={this.toggle} className="modal-event-widget">
                    <ModalHeader tag="h4" toggle={this.toggle} className="text-center">
                        {strings.title}
                        <span className="modal-subtitle">
                            {strings.subtitle1}
                            <Link to={`/client/marketing/`}>{strings.subtitle2}</Link>
                            {strings.subtitle3}
                        </span>
                    </ModalHeader>
                    <ModalBody>
                        <div className="showtix-form__group pb-0">
                            <label className="showtix-label" htmlFor="modal-event-widget__url">{this.props.widgetModalEventName} {strings.directLinkTitle}</label>
                            <p>{strings.descriptionUrl}</p>
                            <div className="showtix-form__input showtix-form__vanity">
                                <div className="showtix-form__input prefix">
                                    <input
                                        className="showtix-input"
                                        id="modal-event-widget__url"
                                        type="text"
                                        readOnly="readonly"
                                        value={this.state.eventPrettyUrl}
                                        onClick={this.copyUrlToClipboard}
                                    />
                                </div>
                            </div>

                            <div className="justify-content-center text-center mt-3">
                                <button
                                    className="showtix-button showtix-background__primary-1"
                                    onClick={this.copyUrlToClipboard}>
                                    {strings.copyUrl}
                                </button>
                            </div>
                            
                            <div className="justify-content-center mt-3">
                                <p>{strings.saveAs}</p>
                                <button
                                    className="showtix-button__download"
                                    onClick={() => this.downloadQRCode()}
                                >
                                    <img src={this.state.qrCode} />
                                </button>
                            </div>
                        </div>

                        <hr />

                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor="modal-event-widget__code-snippet">
                                {this.props.widgetModalEventName} {strings.widgetTitle}
                                <span id="tooltip-widgetTitle" className="showtix-tooltip">!</span>
                                <Tooltip placement="auto" target="tooltip-widgetTitle" className="tooltip-widgetTitle">
                                    <img src={widgetIcon} width="500" alt="Widget" />
                                </Tooltip>
                            </label>
                            <p>{ReactHtmlParser(strings.description)}</p>

                            <textarea
                                readonly
                                className="modal-event-widget__code-snippet"
                                id="modal-event-widget__code-snippet"
                                readOnly="readonly"
                                value={this.state.codeSnippet}
                                onClick={this.copyHtmlToClipboard}
                            >
                            </textarea>

                            <div className="justify-content-center text-center mt-3">
                                <button
                                    className="showtix-button showtix-background__primary-1"
                                    onClick={this.copyHtmlToClipboard}>
                                    {strings.copyCode}
                                </button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

EventWidgetModal.propTypes = {
    isToggleWidgetModalOpen: PropTypes.bool,
    widgetModalEventID: PropTypes.number,
    widgetModalEventName: PropTypes.string,
    toggleWidgetModal: PropTypes.func,
    current_client_id: PropTypes.number
}

export default EventWidgetModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/EventWidgetModal/EventWidgetModal.js